'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp; /**
                    * Created by lyj on 2016/5/11.
                    */


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRadio = require('react-radio');

var _reactRadio2 = _interopRequireDefault(_reactRadio);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PaymentPlatformChoose = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(PaymentPlatformChoose, _Component);

  function PaymentPlatformChoose() {
    (0, _classCallCheck3.default)(this, PaymentPlatformChoose);
    return (0, _possibleConstructorReturn3.default)(this, (0, _getPrototypeOf2.default)(PaymentPlatformChoose).apply(this, arguments));
  }

  (0, _createClass3.default)(PaymentPlatformChoose, [{
    key: 'handleChange',
    value: function handleChange() {
      // console.log(value); value
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var styles = require('./PaymentPlatformChoose.scss');
      var _props = this.props;
      var platforms = _props.platforms;
      var selectedValue = _props.selectedValue;

      var content = [];
      if (platforms instanceof Array) {
        content = platforms.map(function (platformInfo) {
          return {
            value: platformInfo.id,
            label: platformInfo.text,
            style: {
              marginLeft: '20px'
            }
          };
        });
      }

      return _react2.default.createElement(
        'div',
        { className: styles.component },
        _react2.default.createElement(_reactRadio2.default, {
          name: 'payType',
          items: content,
          defaultValue: selectedValue,
          onChange: function onChange(value) {
            return _this2.handleChange(value);
          } })
      );
    }
  }]);
  return PaymentPlatformChoose;
}(_react.Component), _class.propTypes = {
  platforms: _react.PropTypes.array.isRequired,
  selectedValue: _react.PropTypes.string
}, _temp);
exports.default = PaymentPlatformChoose;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/PaymentPlatformChoose/PaymentPlatformChoose.js
 ** module id = 1394
 ** module chunks = 0
 **/